import { selectVehicle } from "action/garage/selectVehicle";
import { LAYOUT } from "constant/layout-constant";
import { IVehicle } from "interfaces/session/IVehicle";
import { IUserSessionUI } from "interfaces/session/user-session-v3";
import qs from "query-string";
import yieldToMain from "util/lodash/yieldToMain";
import {
  ACCOUNT_PAGE,
  FITMENT_TIER_PAGES,
  LINE_PAGES,
  ORDER_STATUS_PAGE,
  PAGE_TYPES,
  RETURN_PAGE,
  SHOPPING_CART_PAGE,
  TIER_MAKE_MODEL_PAGES,
  TIER_MAKE_PAGES,
  TIER_PAGES,
} from "util/product/product-constants";
import shoppingCartCount from "util/shoppingCartCount";
import { isShoppingCartPage } from "util/url/checkRouteInclude";
import { getFragmentParams } from "util/url/getFragmentParams";
import { b2bUrl } from "util/url/static-urls";
import { equalVehicles } from "util/vehicle/equal-vehicles";
import { addVehicle } from "../garage/addVehicle";
import setGarageState from "../garage/setGarageState";
import { setLayout } from "../product/setLayout";
import { refreshShoppingCart } from "../shopping-cart/refreshShoppingCart";
import { setShoppingCartState } from "../shopping-cart/setShoppingCartState";

let hasRefreshedCartOnMount = false;

export function refreshState(browserState: IUserSessionUI) {
  return (dispatch: any, getState: any): void => {
    const { utils, garage } = getState();
    const { currentPageType, urlInformation } = utils;

    if (browserState.shoppingCartState) {
      const {
        deliveryMethod, items, postalCode: zipCode, savedItems, shipmentOption: selectedShipmentOption,
      } = browserState.shoppingCartState;
      dispatch(setShoppingCartState({
        deliveryMethod, numberOfItems: shoppingCartCount(items), zipCode, savedItems, selectedShipmentOption,
      }));
    }

    // setting selectedVehicle and all vehicle
    if (browserState && browserState.catalogState) {
      const { selectedVehicle: previousSessionSelectedVehicle, layout, vehicles } = browserState.catalogState;
      const { tier0 } = urlInformation || {};
      const parsed = qs.parse(location.search);
      const { year: fragmentYear, make: fragmentMake, model: fragmentModel } = getFragmentParams();
      const yearPesent = urlInformation.year || parsed.year || fragmentYear;
      const makePesent = urlInformation.make || parsed.make || fragmentMake;
      const modelPesent = urlInformation.model || parsed.model || fragmentModel;

      let vehicleToSet: IVehicle;
      // set selectedVehicle, on home page, CMS Pages, Static Pages, accounts, shoping cart, PRODUCT_PAGE etc.
      if (
        tier0 === "Tools & Equipment"
        || !currentPageType
        || ["PRODUCT_PAGE", "LANDING_PAGE", "MANUFACTURER_PAGE", ...LINE_PAGES, "STATIC_PAGE", "CHECKOUT_PAGE",
          PAGE_TYPES.ALL_MAKES_PAGE, PAGE_TYPES.ALL_MANUFACTURERS_PAGE, ACCOUNT_PAGE, ORDER_STATUS_PAGE, RETURN_PAGE].includes(currentPageType)
        || [b2bUrl, "/all-parts"].includes(window.location.pathname)
        || isShoppingCartPage(window.location.pathname)
      ) {
        vehicleToSet = previousSessionSelectedVehicle;
      } else if ([
        ...TIER_PAGES,
        ...TIER_MAKE_PAGES,
        ...TIER_MAKE_MODEL_PAGES,
        "MAKE_PAGE",
        "MAKE_MODEL_PAGE",
        "PRODUCT_MAKE_MODEL_PAGE",
      ].includes(currentPageType)) {
        if (yearPesent && makePesent && modelPesent) {
          const vehicleToBeSet: IVehicle = {
            make: makePesent,
            model: modelPesent,
            year: parseInt(yearPesent, 10),
            fitmentOptions: [],
            ...(previousSessionSelectedVehicle?.colorData && { colorData: previousSessionSelectedVehicle.colorData }),
          };
          // for SSR
          // http://localhost:3000/honda-civic-suspension-parts?year=2010
          // http://localhost:3000/honda-civic-suspension-parts#year=2010  T2
          // http://localhost:3000/honda-civic-axles-drivetrain#year=2010  T1 (Problem)
          // http://localhost:3000/suspension-systems?make=HONDA&model=CIVIC&year=2008
          const currentOldVehicle = vehicles.filter((_: any) => equalVehicles(_, vehicleToBeSet));
          if (currentOldVehicle && currentOldVehicle[0]) {
            // For old user, might have engine allready selected in all vehicles
            [vehicleToSet] = currentOldVehicle;
          } else {
            // For first time or new user
            vehicleToSet = vehicleToBeSet;
          }
        } else if (previousSessionSelectedVehicle
          && previousSessionSelectedVehicle.make === urlInformation.make
          && previousSessionSelectedVehicle.model === urlInformation.model) {
          // ex: http://localhost:3000/honda-civic-axles-drivetrain
          // https://partsavatar.ca/2000-2007-volkwagen-golf-new-blower-motor-with-wheel-uac-bm9399c
          vehicleToSet = previousSessionSelectedVehicle;
        } else {
          vehicleToSet = null;
        }
      } else if (FITMENT_TIER_PAGES.includes(currentPageType)) {
        // find SSR vehicle is in allVehicles, for FO information.
        const currentOldVehicle = vehicles.filter((_: any) => equalVehicles(_, garage.selectedVehicle));
        // set vehicle from all vehicles, as it can have engine information. else SSR vehcile
        vehicleToSet = currentOldVehicle && currentOldVehicle[0] ? currentOldVehicle[0] : garage.selectedVehicle;
      } else {
        vehicleToSet = null;
      }

      dispatch(selectVehicle(vehicleToSet, false));
      dispatch(setGarageState({ selectedVehicle: vehicleToSet, vehicles }));
      dispatch(addVehicle(vehicleToSet, true));

      yieldToMain()
        .then(() => {
          const productListLayout = browserState.businessCustomer ? LAYOUT.COMPACT : layout;
          dispatch(setLayout(productListLayout));
        });
    }

    if (currentPageType !== SHOPPING_CART_PAGE || hasRefreshedCartOnMount) {
      yieldToMain()
        .then(() => {
          dispatch(refreshShoppingCart(null, { loader: false }));
        });
    }

    // Prevent duplicate api call on shopping cart page mount
    if (currentPageType === SHOPPING_CART_PAGE && !hasRefreshedCartOnMount) {
      hasRefreshedCartOnMount = true;
    }
  };
}
